module.exports = __webpack_public_path__ + "img/dui1.8a5351b6.png";